import React, { useState } from "react";
import {
    StyledIcon,
    TalentSupportMail,
} from "../custom-styles/new-edit-form/NewEditForm.styles";

import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";

const ContactSupport = ({
    userOffice
}) => {

    const [supportMailTooltipText, setSupportMailTooltipText] = useState("");

    const setTalentSupportEmail = () => {
        if (navigator?.clipboard) {
            navigator.clipboard.writeText(
                userOffice.data?.TalentSupportEmail ?? ""
            );
            setSupportMailTooltipText("Copied");
        }
    };

    return (
        <HStack spacing="Zero_5">
            <Text variant="Body_2_1" color="Gray_2">
                If there are any issues, please contact
            </Text>
            <>
                <TalentSupportMail
                    spacing="Zero_25"
                    onMouseEnter={() => setSupportMailTooltipText("Copy")}
                    onMouseLeave={() => setSupportMailTooltipText("")}
                    onClick={() => setTalentSupportEmail()}
                >
                    <Text
                        variant="Body_2_2"
                        color="Black"
                    >
                        Talent Support
                    </Text>
                    <StyledIcon name="mail" />
                </TalentSupportMail>
                <Text
                    variant="Body_2_1"
                    color="Gray_2"
                >
                    {supportMailTooltipText}
                </Text>
            </>
        </HStack>
    );
};

ContactSupport.propTypes = {
    userOffice: PropTypes.object
};

export default ContactSupport;
